import { useCallback } from 'react';
import { Box, Button, Stack } from '@mui/material';

import { snackbar } from '@occc-app/design-system';
import { Typography } from '@occc/ui-design-system';

type LocationActivityDetailsProps = {
  title: string;
  rawMessage: string;
  onClose: () => void;
};

const LocationActivityDetails = ({ title, rawMessage, onClose }: LocationActivityDetailsProps) => {
  const handleCopyToClipboardButtonClick = useCallback(() => {
    navigator.clipboard.writeText(rawMessage);
    snackbar.success('Copied to clipboard');
  }, [rawMessage]);

  return (
    <Stack spacing={3}>
      <Box
        borderRadius='8px'
        fontFamily='monospace'
        maxHeight='65vh'
        overflow='auto'
        sx={({ palette, spacing }) => ({
          border: `1px solid ${palette.divider}`,
          background: palette.grey[200],
          p: spacing(1, 2),
        })}
      >
        <Typography variant='h5'>{title}</Typography>
        <Box
          mt={1}
          whiteSpace='pre'
          fontSize='1.4rem'
          color={({ palette }) => palette.text.primary}
        >
          {rawMessage}
        </Box>
      </Box>
      <Stack direction='row' spacing={2} justifyContent='flex-end'>
        <Button onClick={onClose}>Close</Button>
        <Button variant='contained' color='primary' onClick={handleCopyToClipboardButtonClick}>
          Copy to clipboard
        </Button>
      </Stack>
    </Stack>
  );
};

export default LocationActivityDetails;
